import { createFileRoute } from "@tanstack/react-router";
import VatToolPage from "@/features/public/pages/tools/vat";

export const Route = createFileRoute("/(public)/_public/tools/vat")({
  component: VatToolPage,
});
